export const PROFILE_PASSWORD_UPDATE_REQUEST = 'profile/password-update-request'
export const PROFILE_PASSWORD_UPDATE_SUCCESS = 'profile/password-update-success'
export const PROFILE_PASSWORD_UPDATE_FAILED = 'profile/password-update-failed'
